import { PaymentMethodEnum, PaymentMethodType } from 'models';

export const PaymentMethodTypes: PaymentMethodType[] = [
  {
    id: PaymentMethodEnum.CreditCard,
    title: 'ENTITY.PAYMENT-METHOD.CREDIT-CARD.TITLE',
    images: [
      {
        alt: 'Visa',
        src: '/assets/images/icon-payment-visa-color.svg'
      },
      {
        alt: 'MasterCard',
        src: '/assets/images/icon-payment-mastercard-color.svg'
      },
      {
        alt: 'PostePay',
        src: '/assets/images/icon-payment-postepay-color.svg'
      },
      {
        alt: 'American Express',
        src: '/assets/images/icon-payment-amex-color.svg'
      }
    ]
  },
  {
    id: PaymentMethodEnum.PayPal,
    title: 'ENTITY.PAYMENT-METHOD.PAYPAL.TITLE',
    images: [
      {
        alt: 'Paypal',
        src: '/assets/images/icon-payment-paypal.svg'
      }
    ]
  },
  {
    id: PaymentMethodEnum.PayByLink,
    title: 'ENTITY.PAYMENT-METHOD.PAY-BY-LINK.TITLE'
  },
  {
    id: PaymentMethodEnum.NoVSC,
    title: 'ENTITY.PAYMENT-METHOD.NOVSC.TITLE'
  },
  {
    id: PaymentMethodEnum.Mock,
    title: 'Pagamento di test',
    images: []
  }
];
